import React, { useState, useEffect } from 'react';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { useLocation } from 'react-router-dom';
import { Link, useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';


const EditCategory = () => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
const location = useLocation();
  const navigate = useNavigate();
const category = location.state?.data;

  useEffect(() => {
    if (category) {
      setName(category.name || '');
    }
  }, [category]);

  const handleEditCategory = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setError('Category name is required.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await DataService.updateCategory({ id: category.id, name });
       setLoading(false);
      toast.success('Category updated Successfully.');
      navigate('/categories')
    } catch (err) {
      setError('Failed to update category.');
    } finally {
      setLoading(false);
    }
  };

  if (!category) {
    return <div className="container mt-4">No category selected for editing.</div>;
  }
const goBack = () => navigate(-1); // navigate back to previous page

  return (
   <>
      <LoaderOverlay loading={loading} />

      <h4>Edit Category</h4>

      <form onSubmit={handleEditCategory} className="mt-3">
        <div className="mb-3">
          <label className="form-label">Category Name</label>
          <input
            type="text"
            className="form-control  px-3"
            placeholder="Enter category name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <button type="submit" className="btn btn-primary">
          Update Category
        </button>
                <button type="button" className="btn btn-outline-secondary" style={{marginLeft:'15px'}} onClick={goBack}>

    ← Back
  </button>
      </form>
      </>

  );
};

export default EditCategory;
